import React from 'react';
import compose from '../../hoc/compose';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var Divider = function Divider(props) {
  var newProps = {
    className: classNames(props.getClassName(props["long"] ? 'divider-long' : 'divider-short'), props.getClassName("divider-".concat(props.direction))),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  };
  return /*#__PURE__*/React.createElement('hr', newProps);
};
Divider.displayName = 'Divider';
Divider.propTypes = {
  /**  Controls divider direction */
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Makes the divider coast to coast */
  "long": PropTypes.bool
};
Divider.defaultProps = {
  "long": false,
  direction: 'horizontal'
};
export default compose(Divider);